<div class="container">
    <div class="row text-center">
        <div class="col-md-12">
            <p style="font-size: 84px;color: #f7a321;"><i class="far fa-frown"></i></p>
            <h1 style="font-size: 80px; color:#aaa;">404</h1>
            <h3 style="font-size: 45px;">Page not Found!</h3>
            <br>
            <p><button class="btn btn-outline-dark" routerLink="/insertion-order">Go Back</button></p>
        </div>
    </div>

</div>
